const SCRIPT_SRC = 'https://checkout.razorpay.com/v1/checkout.js';

export function loadRazorpay() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

export function openCheckout({ key, subscriptionId, description, prefill, onSuccess, onDismiss, onFailed }) {
  const rzp = new window.Razorpay({
    key,
    subscription_id: subscriptionId,
    name: 'MLink',
    description,
    prefill,
    theme: { color: '#7a0d0d' },
    handler: onSuccess,
    modal: { ondismiss: onDismiss },
  });
  rzp.on('payment.failed', (response) => {
    if (onFailed) onFailed(response && response.error && response.error.description);
  });
  rzp.open();
}